import React from "react";
import { Anchor } from "antd";
import "./style.css";

const { Link } = Anchor;

export class RightAnchor extends React.Component {
  constructor(props) {
    super(props);
    this.state = { page: "#tech1" };
  }
  componentDidMount(){
    this.props.domId&&this.setState({ page: "#"+ this.props.domId});
  }

  render() {
    return (
      <div className="right_anchor">
        <Anchor
          affix={false}
          onChange={(link) => {
            this.setState({ page: link });
            // window.location.hash = link;
          }}
          showInkInFixed={true}
        >
          <Link href="#tech1" title="">
            <a href="#tech1">
              <div
                className={this.state.page === "#tech1" ? "anchor_active" : ""}
              ></div>
              <img className="tech_anchor" src="./img/88.png" />
            </a>
          </Link>
          <Link href="#tech2" title="">
            <a href="#tech2">
              <div
                className={this.state.page === "#tech2" ? "anchor_active" : ""}
                ></div>
              <img className="tech_anchor" src="./img/89.png" />
            </a>
          </Link>
          <Link href="#tech3" title="">
            <a href="#tech3">
              <div
                className={this.state.page === "#tech3" ? "anchor_active" : ""}
                ></div>
              <img className="tech_anchor" src="./img/555.png" />
            </a>
          </Link>
          <Link href="#tech4" title="">
            <a href="#tech4">
              <div
                className={this.state.page === "#tech4" ? "anchor_active" : ""}
                ></div>
              <img className="tech_anchor" src="./img/85.png" />
            </a>
          </Link>
          <Link href="#tech5" title="">
            <a href="#tech5">
              <div
                className={this.state.page === "#tech5" ? "anchor_active" : ""}
                ></div>
              <img className="tech_anchor" src="./img/444.png" />
            </a>
          </Link>
          <Link href="#tech6" title="">
            <a href="#tech6">
              <div
                className={this.state.page === "#tech6" ? "anchor_active" : ""}
                ></div>
              <img className="tech_anchor" src="./img/23.png" />
            </a>
          </Link>
        </Anchor>
      </div>
    );
  }
}
